import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { styled } from '../../lib/stitches'
import { useTreeState } from '../../stores/Root'
import { Box, CloseButton, Row } from '../core/Components'
import { Flex } from '../core/Flex'
import { StemIcon } from '../core/icons'
import { Subtitle } from '../core/Subtitle'
import { Title } from '../core/Title'
import { gray3, gray7 } from '../platform/color'
import DiscoverContent from './discover-stems/DiscoverContent'
import useHandleRef from './hooks/useHandleRef'
import { DrawerHandle, SelectedTrackContainerContainer } from './SelectedTrackContainer'

const HeaderIcon = styled(StemIcon, {
  marginRight: '10px'
})

const Header: FC = observer(() => {
  const { studio } = useTreeState()
  const close = () => studio.setShowDiscoverStemsDrawer(false)

  return (
    <Flex
      direction="column"
      width="full"
      css={{
        padding: '0 25px',
        borderBottom: `${gray3} 1px solid`,
        minHeight: '100px',
        justifyContent: 'center'
      }}
    >
      <Row justifySpaceBetween verticalCenter>
        <Row verticalCenter>
          <HeaderIcon />
          <Title>Browse Stems</Title>
        </Row>
        <CloseButton close={close} />
      </Row>
      <Row verticalCenter>
        <Subtitle css={{ color: gray7, marginBottom: 0 }}>
          Browse stems and add to your draft by clicking "add to song"
        </Subtitle>
      </Row>
    </Flex>
  )
})

interface Props {
  height: string
  width: string
  onResize: (resizeHeight: number) => void
}
const DiscoverStemsBottomDrawer: FC<Props> = ({ height, width, onResize }) => {
  const handleRef = useHandleRef(onResize)
  return (
    <SelectedTrackContainerContainer height={height} width={width} padding="0">
      <DrawerHandle ref={handleRef} />
      <Header />
      <Box css={{ height: 'calc(100% - 100px)' }}>
        <DiscoverContent />
      </Box>
    </SelectedTrackContainerContainer>
  )
}

export default DiscoverStemsBottomDrawer
